var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRanus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 24,
    viewBox: "0 0 77 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.6436 6.68328H76.4998V4.5H66.3835C65.4903 4.5 64.6336 4.84471 64.002 5.45829C63.3704 6.07187 63.0156 6.90407 63.0156 7.77181V13.2082H71.9794V16.48C71.9778 16.7645 71.8617 17.037 71.6559 17.2392C71.45 17.4415 71.1709 17.5575 70.8782 17.5624H63.0156V19.7456H73.1255C73.568 19.7465 74.0064 19.6624 74.4153 19.4983C74.8243 19.3341 75.1959 19.0932 75.5088 18.7892C75.8217 18.4852 76.0698 18.1242 76.2387 17.7269C76.4077 17.3295 76.4942 16.9037 76.4934 16.4738V11.0436H67.5296V7.77181C67.5295 7.48419 67.6467 7.20825 67.8555 7.00429C68.0642 6.80033 68.3476 6.68492 68.6436 6.68328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M56.3653 4.5V17.5624H54.1179C53.523 17.5624 52.9524 17.3332 52.5311 16.9251C52.1098 16.517 51.8723 15.9633 51.8706 15.3853V4.5H47.3887V15.4102C47.3887 16.565 47.8609 17.6724 48.7014 18.489C49.5419 19.3056 50.6819 19.7643 51.8706 19.7643H60.8344V4.5H56.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.2353 19.7705V6.70816H38.4826C39.0715 6.7081 39.6367 6.9332 40.056 7.33477C40.4754 7.73635 40.7152 8.28213 40.7236 8.85412V19.7705H45.2055V8.85412C45.2055 7.69934 44.7333 6.59185 43.8928 5.77529C43.0523 4.95874 41.9123 4.5 40.7236 4.5H31.7598V19.7705H36.2353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.9457 9.95509V8.85412C13.9457 7.69934 13.4735 6.59185 12.633 5.77529C11.7925 4.95874 10.6525 4.5 9.46383 4.5H0.5V19.7705H4.98191V6.70816H7.22927C7.81649 6.71133 8.37911 6.93766 8.79673 7.33872C9.21435 7.73978 9.4538 8.28372 9.46383 8.85412V9.95509C9.46383 10.5341 9.22705 11.0895 8.80559 11.4989C8.38413 11.9083 7.8125 12.1384 7.21647 12.1384H6.1152V14.3154H7.23568C7.82838 14.3203 8.39508 14.5525 8.8124 14.9615C9.22971 15.3704 9.46385 15.9229 9.46383 16.4987V19.7705H13.9457V16.4987C13.9526 15.8787 13.823 15.2644 13.5658 14.6969C13.3085 14.1294 12.9294 13.6219 12.4539 13.2082C12.9245 12.7988 13.3007 12.2973 13.5578 11.7366C13.8149 11.176 13.9471 10.5689 13.9457 9.95509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6089 4.5C19.4202 4.5 18.2802 4.95874 17.4397 5.77529C16.5992 6.59185 16.127 7.69934 16.127 8.85412V19.7705H20.6089V14.3154H23.9767V12.1384H20.6089V8.85412C20.6089 8.27673 20.845 7.72298 21.2652 7.31471C21.6855 6.90643 22.2555 6.67706 22.8498 6.67706H25.0972V19.7394H29.5791V4.5H20.6089Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanus);
export default __webpack_public_path__ + "static/media/Ranus.0e4bd5699639dfe47f1886cf7e06711d.svg";
export { ForwardRef as ReactComponent };